"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeadZone = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const index_1 = require("../../DefinitionAndHelpers/index");
const EffluentTracker_1 = require("../Effluent/EffluentTracker");
const LateralEffluentSpreader_1 = require("../Effluent/LateralEffluentSpreader");
const PivotEffluentSpreader_1 = require("../Effluent/PivotEffluentSpreader");
const SpreadingGun_1 = require("../Effluent/SpreadingGun");
const TravellingEffluentSpreader_1 = require("../Effluent/TravellingEffluentSpreader");
const typeName = 'DeadZone';
class DeadZone extends datamodel_core_1.Area {
    constructor(ob) {
        var _a, _b, _c;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.path = ob.path;
        this.spreaderID = ob.spreaderID;
        this.runDifference = ob.runDifference;
        this.irrigatedArea = ob.irrigatedArea;
        this.ttl = ob.ttl;
        this.filteredPath = (_b = ob.filteredPath) !== null && _b !== void 0 ? _b : null;
        this.mappedPath = (_c = ob.mappedPath) !== null && _c !== void 0 ? _c : null;
    }
    getCoverageAndArea(spreaderList, filter = 'Mapped', effluentRuns) {
        var _a, _b, _c;
        let useLogic = this._areaPointsMapping;
        if (useLogic === undefined) {
            let matchedSpreader = spreaderList.find((spreader) => spreader.id === this.spreaderID);
            if (matchedSpreader === undefined) {
                return this.irrigatedArea;
            }
            let details = { ...matchedSpreader, path: this.path };
            let shallowCopy;
            switch (matchedSpreader.type) {
                case 'PivotEffluentSpreader':
                    shallowCopy = new PivotEffluentSpreader_1.PivotEffluentSpreader(details);
                    break;
                case 'LateralEffluentSpreader':
                    shallowCopy = new LateralEffluentSpreader_1.LateralEffluentSpreader(details);
                    break;
                case 'TravellingEffluentSpreader':
                    shallowCopy = new TravellingEffluentSpreader_1.TravellingEffluentSpreader(details);
                    break;
                case 'SpreadingGun':
                    shallowCopy = new SpreadingGun_1.SpreadingGun(details);
                    break;
                default:
                    shallowCopy = new EffluentTracker_1.EffluentTracker(details);
            }
            if (effluentRuns) {
                // dynamically search for runs
                let filteredRuns = shallowCopy.getRelevantRuns(effluentRuns);
                shallowCopy.path = this.path;
                let expectedPathObj = index_1.EffluentSpreaderHelper.getExpectedRunLine(shallowCopy, filteredRuns);
                if (expectedPathObj) {
                    let runRes = shallowCopy.getSpreadOfAllRuns(expectedPathObj.run);
                    this._areaPointsMapping = runRes;
                    useLogic = runRes;
                }
            }
        }
        switch (filter) {
            case 'Raw':
                return ((_a = useLogic === null || useLogic === void 0 ? void 0 : useLogic.raw) === null || _a === void 0 ? void 0 : _a.positions) || this.irrigatedArea;
            case 'Filtered':
                return ((_b = useLogic === null || useLogic === void 0 ? void 0 : useLogic.filtered) === null || _b === void 0 ? void 0 : _b.positions) || this.irrigatedArea;
            default:
                return ((_c = useLogic === null || useLogic === void 0 ? void 0 : useLogic.mapped) === null || _c === void 0 ? void 0 : _c.positions) || this.irrigatedArea;
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: {
                    regex: /^[\p{L}0-9\s']+$/u,
                    pass: false,
                    invalidMessage: 'Name cannot contain invalid characters',
                },
            },
            output: {
                type: 'Number',
                editable: false,
                label: 'Output (L)',
                name: 'output',
                description: 'Flow output of run',
            },
            duration: {
                type: 'Number',
                editable: false,
                label: 'Duration (min)',
                name: 'duration',
                description: 'Effluent Spreading Duration',
            },
            description: {
                type: 'String',
                editable: true,
                label: 'Description',
                description: 'description',
            },
            concentration: {
                type: 'Number',
                editable: false,
                label: 'Concentration (L/m^2)',
                name: 'concentration',
                description: 'Concentrate of effluent for this run',
            },
        };
    }
}
exports.DeadZone = DeadZone;
